import React, { useState, useRef } from 'react'
import compose from 'recompose/compose'
import { withI18n } from '../../hocs'
import PropTypes from 'prop-types'
import * as S from './styled'
import ActionDialog from '../action-dialog'
import { InputField } from '../../atoms'

const ModalUpdateBlacklist = ({ open, handleClose, i18n, name, isOnBlacklist, handleOnClickUpdateBlacklist }) => {
  const [disableButton, setDisableButton] = useState(true)
  const formRef = useRef(null)

  function handleOnChange(value) {
    if (value === name) {
      setDisableButton(false)
    } else {
      setDisableButton(true)
    }
  }

  // Se devuelve la petición del padre para que ActionDialog muestre el spinner; el campo se
  // limpia solo si ha ido bien, para poder reintentar sin volver a escribir el nombre
  function handleUpdateBlacklistButton() {
    return Promise.resolve(handleOnClickUpdateBlacklist()).then(() => {
      setDisableButton(true)
      // Antes lo hacía el type="reset" del botón; ahora el botón vive fuera del form
      formRef.current && formRef.current.reset()
    })
  }

  return (
    <ActionDialog
      open={open}
      title={`${isOnBlacklist ? i18n.modalUpdateBlacklist.removeFromBlacklist : i18n.modalUpdateBlacklist.addToBlacklist} ${name}`}
      onClose={handleClose}
      onConfirm={handleUpdateBlacklistButton}
      cancelLabel={i18n.dialog.decline}
      confirmLabel={isOnBlacklist ? i18n.modalUpdateBlacklist.remove : i18n.modalUpdateBlacklist.add}
      confirmDisabled={disableButton}
      disableBackdropClose
    >
      <form ref={formRef} onSubmit={e => e.preventDefault()}>
        <S.Label>{i18n.modalUpdateBlacklist.enterCandidateName}</S.Label>
        <InputField handleOnChange={handleOnChange} placeholder={i18n.modalUpdateBlacklist.writeCandidateName} name="message" />
      </form>
    </ActionDialog>
  )
}

ModalUpdateBlacklist.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  i18n: PropTypes.object.isRequired,
  name: PropTypes.string,
  handleOnClickUpdateBlacklist: PropTypes.func
}

const enharce = compose(withI18n)

export default enharce(ModalUpdateBlacklist)
